export default __webpack_public_path__ + "static/media/LeftMenu.6aef20fb.svg";